import { Box, Typography, Divider, Container, List, ListItem, Card, useTheme } from "@mui/material";
import { Helmet } from "react-helmet-async";

const TermsAndConditions = () => {
    const theme = useTheme();
  return (
    <Box display="flex" justifyContent="center" py={6}>
  <Card sx={{ width: 'fit-content', maxWidth: '100%', boxShadow: 3, p: 2 }}>
    <Container maxWidth="md" sx={{ fontSize: 16, color: theme.palette.text.primary}}>
       <Helmet>
        <title>TERMENI ȘI CONDIȚII</title>
      </Helmet>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center" color="inherit">
        TERMENI ȘI CONDIȚII
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Prezenții Termeni și Condiții de utilizare a magazinului online www.portal.s2.avangardmed.md sunt aplicabile comenzilor pentru achiziționarea produselor/serviciilor oferite de compania AVANGARD-MED S.R.L. prin intermediul site-ului.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Pentru folosirea în bune condiții a site-ului, vă recomandăm familiarizarea cu atenție a Termenilor și Condiții-lor prezentate. Ne rezervăm dreptul de a face modificări ale acestor prevederi, fără o notificare prealabilă.
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        1. DISPOZIȚII GENERALE
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Acest site este deținut de AVANGARD-MED S.R.L. La înregistrarea comenzii in magazinul online, Cumpărătorul  accepta Termeni si Condițiile de vânzare a bunurilor/produselor și/sau prestare a serviciilor  care sunt bazați pe legislația RM (in continuare – Termeni și Condiții) prezentate mai jos.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Utilizarea website-ului presupune acceptarea Termeni si Condiții propuse de către AVANGARD-MED S.R.L., în conformitate cu Legea nr.284/2004 privind Comerțul Electronic. Relațiile dintre client si vânzător sunt stabilite în baza Legii nr.105/2003 cu privire la Protecția drepturilor consumatorului, si a altor acte normative adoptate în conformitate cu aceasta.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Vânzătorul își rezerva dreptul de a modifica Termenii si Condițiile date, iar Cumpărătorul este obligat sa monitorizeze modificările.
      </Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        2. PROTECȚIA DATELOR CU CARACTER PERSONAL
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Prin utilizarea site-ului www.portal.s2.avangardmed.md, sunteți de acord în mod automat cu colectarea și prelucrarea datelor cu caracter personal, care sunt necesare pentru procesarea/confirmarea/executarea comenzilor.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Datele personale se prelucrează doar pentru scopuri legitime, precum acela de a furniza produsele pe care le comanzi, promoții, google analytics, cookies și notificări\newsletter.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Toată informația ce conține date cu caracter personal este stocată și utilizată doar pentru perioada necesară atingerii scopurilor pentru care a fost colectată și în conformitate cu prevederile stabilite de Legea nr. 133/2011 privind protecția datelor cu caracter personal.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Noi folosim măsuri de securitate comerciale pentru a preveni accesul neautorizat, menținerea exactității date-lor și pentru asigurarea utilizării corecte a informației de pe site. Transmiterea datelor pe internet sau prin rețea wireless nu poate fi protejata în totalitate. Prin urmare, la fel ca alte companii, noi nu putem garanta securitatea informației pe care o oferă Cumpărătorului, astfel, el va face acest lucru pe propria răspundere.
      </Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        3. ÎNREGISTRAREA ȘI ACHITAREA COMENZII
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Achitarea comenzilor este posibilă cu cardul de plată – la primirea comenzii veți primi bonul fiscal ce va confirma plata. 
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Plata online se face în condiții de siguranța maxima folosind ca instrument de plată cardul de plată, care permite efectuarea de tranzacții online. După efectuarea plății veți primi o confirmare de plata pe adresa dvs. de email.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Procesatorul de plata folosește un sistem securizat, bazat pe ultima versiunea a standardului de securitate 3D-Secure ceea ce înseamnă o nouă abordare globală a autentificării cumpărătorilor în tranzacții sigure online. Aceasta măsura de siguranța presupune redirecționarea utilizatorului în momentul efectuării plații pe o pagina securizata maib unde autentificarea fiecărui deținător de card se face prin atribuirea unui cod de unică folosințe pentru fiecare tranzacție online.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Rambursarea mijloacelor bănești se efectuează doar pe cardul de plată care a fost folosit pentru achiziție.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Pentru a efectua o plată, va trebui să introduceți detaliile cardului dvs. bancar. Transferul acestor informații se face în conformitate cu toate măsurile de securitate necesare. Informațiile sunt transmise în formă criptată și sunt stocate numai pe un server specializat al sistemului de plăți.
      </Typography>
      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Pentru efectuarea plății vor fi solicitate următoarele date:
      </Typography>
      <List >
        <ListItem>
          <Typography variant="body1">
            o	Pentru efectuarea plății vor fi solicitate următoarele date:
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            o	Data expirării (luna și anul)
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            o	Codul CVC sau CVV (3 cifre)
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            o	Numele și prenumele de pe cardul de plată
          </Typography>
        </ListItem>
      </List>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        În cazul în care valuta cardului diferă de valuta tranzacției (MDL), atunci la convertirea sumei reținute din contul de card se vor aplica condițiile băncii emitente.
      </Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        4. DREPTUL LA RETUR  
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        <b>Conform noțiunii din Legea nr. 105-XV din 13 martie 2013 privind protecția consumatorilor</b> Cumpărătorul are dreptul de a returna produs/marfa procurată din anumite motive în timp de 14 zile de la ziua achitării. Mijloacele bănești sunt returnate pe cardul de pe care s-a efectuat cumpărătura.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        <b>Articolele de articole exemplu nu pot fi schimbate sau returnate</b>, în conformitate cu  Anexa nr.2 a Hotărârii Guvernului №1465 din 08.12.2003 (MO248-253/19.12.2003), în redacția Hotărârii Guvernului №1188 din 02.11.2007 (МО175/09.11.2007).
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Contactele companiei in caz de retur: +373 68 100 730 <br />
        Termenul de procesare a cererii de retur: 5 zile <br />
        Condițiile de retur:
      </Typography>
      <List >
        <ListItem>
          <Typography variant="body1">
            Înnaintarea cererii de retur în termen de 14 zile de la achitare (prin email cu semnătură electronică, sau în cabinetul personal prin autentificare /logare a utilizatorului; cerere trebuie să conțină numele, prenumele utilizatorului, numărul de comandă, data plății, serviciul achitat, motivul cererii)
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            Utilizatorul are dreptul de a cere sa i se restituie contravaloarea serviciilor medicale neefectuate
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            Programarea a fost anulată cu cel puțin 24 de ore înainte de ora stabilită
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1">
            Utilizatorul nu poate solicita restituirea banilor în caz de neprezentare neanunțată.
          </Typography>
        </ListItem>
      </List>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        5. POLITICA DE CONFIDENȚIALITATE
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        În conformitate cu prevederile Legii Nr.133/2011 privind protecția datelor cu caracter personal, furnizorul de servicii prelucrează date cu caracter personal. Datele cu caracter personal sunt prelucrate cu buna-credință și se face în temeiul și în conformitate cu prevederile legale. Prelucrarea datelor cu caracter personal se realizează prin mijloace mixte (automate și manuale), cu respectarea cerințelor legale și în condiții care să asigure securitatea, confidențialitatea și respectarea drepturilor persoanelor vizate.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Furnizorul colectează și prelucrează doar datele personale furnizate de consumatori la efectuarea comenzii: nume, prenume, număr de telefon, adresa, adresa poștală.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Datele personale sunt utilizate exclusiv în scopul administrării site-ului, pentru a permite accesul la informații special, pentru livrarea comenzilor sau pentru a contacta consumatorul în vederea executării livrării. Prin prezenta informare, utilizatorii și consumatorii iau cunoștință despre faptul că li se vor prelucra și utiliza datele cu caracter personal (nume, prenume, număr de telefon, adresa, adresa poștală). Furnizorul de servicii prelucrează datele cu caracter personal ale utilizatorilor și consumatorilor care sunt furnizate prin navigarea, folosirea și înregistrarea pe site-ul www.portal.s2.avangardmed.md
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Orice informație furnizată de către utilizatorii și consumatorii site-ului www.portal.s2.avangardmed.md, va fi considerată și va reprezenta consimțământul expres ca datele personale să fie folosite de Furnizor.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Furnizorul nu va dezvălui unei terțe părți niciuna dintre datele deținute, fără acordul persoanelor vizate și nu va comercializa, schimba, divulga aceste date cu alte persoane, cu excepțiile prevăzute de legislația în vigoare (la solicitarea instituțiilor publice ale statului, organele de drept, instanțelor de judecată, de asemenea autorizate să prelucreze date cu caracter personal).
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Datele cu caracter personal pot fi prelucrate și utilizate de către Furnizor și în scopuri statistice și de promovare ulterioară. 
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Furnizorul de servicii îndeplinește cerințele de securitate a datelor cu caracter personal și asigură protecția datelor consumatorilor și le protejează pentru a nu fi pierdute, distruse, distorsionate/falsificate sau divulgate terțelor persoane.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Angajații furnizorului de servicii sunt obligați să respecte confidențialitatea datelor personale ale consumatorilor. Prelucrarea datelor cu caracter personal va fi realizată de persoana împuternicită a Furnizorului.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Furnizorul utilizează metode și tehnologii de securitate conform prevederilor legale în vigoare.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Furnizorul nu colectează informații referitoare la tranzacții, cum ar fi nr. la card, data expirării, țara de origine.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Pentru mai multe detalii și informații orice persoană interesată se poate adresa printr-un email la clinica@avangardmed.md sau prin telefon la numărul +373 68 100 730
      </Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        6. DATELE DE CONTACT 
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        Denumirea juridica a companiei: AVANGARD-MED S.R.L.
      </Typography>
      <Typography variant="body1" sx={{ mb:1, whiteSpace: 'pre-line', textAlign: 'justify' }}>
        IDNO: 1024600007727 <br />
Adresa juridica: Chisinau, str. Burebista, 23<br />
Adresa fizica: Chisinau, str. Burebista, 23 <br />
Telefon de contact: +373 68 100 730<br />
Email de contact: clinica@avangardmed.md

      </Typography>
    </Container>
    </Card>
    </Box>
  );
};

export default TermsAndConditions;
